import { Dialog, useDialogManager } from '../../widgets/dialog';
import React, { FC, Suspense } from 'react';
import { AddSalesChannelsDialogWindow, ApiLabel } from '../../../shared/connectDialogStyle';
import { Loader } from '../../../shared/docsDialog';
import ApiKeys from '../myAccount/apiKeys';

interface ApiKeyDialogProps {
    salesChannelID: string;
}

const ApiKeyDialog: FC<ApiKeyDialogProps> = ({ salesChannelID }) => {
    const { closeDialog } = useDialogManager();

    return (
        <Dialog windowDecorator={AddSalesChannelsDialogWindow} onClose={() => closeDialog('api-key')}>
            <Suspense fallback={Loader}>
                <div>
                    <ApiLabel
                        dangerouslySetInnerHTML={{
                            __html: `<strong><h2>API Keys</h2></strong>`
                        }}
                    />
                    <ApiKeys salesChannelID={salesChannelID} />
                </div>
            </Suspense>
        </Dialog>
    );
};

export default ApiKeyDialog;
